export enum CleaningType {
  UNKNOWN = "unknown",
  BASIC = "basicCleaning",
  DEEP = "deepCleaning",
  CUSTOM = "customCleaning",
}
